import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GmailIntegrationsResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GmailIntegrationsResponseDataSchema>>

const queryKey = ["gmailIntegrations"]

export const gmailIntegrationsQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/gmail`)

      return response.data.data
    },
  })
}
